export default __webpack_public_path__ + "static/media/Path 729.6c356bfb.svg";